const TERMINAL_AUTH_ERROR_CODES = new Set([
  'login_required',
  'consent_required',
  'interaction_required',
  'account_selection_required',
  'invalid_grant',
  'missing_refresh_token',
  'missing_session',
]);

export function isTerminalAuthError(error: unknown): boolean {
  const code = (error as { error?: unknown } | null)?.error;
  return typeof code === 'string' && TERMINAL_AUTH_ERROR_CODES.has(code);
}
